import accountModule from '../../../app.js';
import favoriteListTemplate from './favorite-list.html';
import {configManager, userProfileManager, strings, AccountConfigManager} from '@nuskin/ns-common-account';

import favoriteListController from './favorite-list';

accountModule.service('favConfigManager', function() {
    return configManager;
});
accountModule.service('favUserProfileManager', function() {
    return userProfileManager;
});
accountModule.service('strings', function() {
    return strings;
});
accountModule.service('AccountConfigManager', function() {
    return AccountConfigManager;
});

favoriteListController.$inject = ['$http', '$window', 'personalService', '$rootScope', 'favUserProfileManager',
    'favConfigManager', 'strings', 'AccountConfigManager'];

accountModule.controller('favoriteListController', favoriteListController);

accountModule.component('nsFavoritesList', {
    template: favoriteListTemplate,
    bindings: {
        accountId: '=',
        accountView: '='
    },
    controller: favoriteListController,
    controllerAs: 'ctrl',
    bindToController: true,
});



//////////////////
// WEBPACK FOOTER
// ./angular/components/favorite-list/favorite-list-adapter.js
// module id = 367
// module chunks = 0